import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { ALERT_TYPE } from 'src/app/constants';
import { Account } from 'src/model/account.model';
import { Arrear } from 'src/model/arrear.model';
import { Loan } from 'src/model/loan.model';

@Component({
    selector: 'app-loan-arrear',
    templateUrl: './loan-arrear.component.html',
    styleUrls: ['./loan-arrear.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class LoanArrearComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);

  arrearList: Arrear[] = [];
  unpaidArrearList: Arrear[] = [];
  companyAccountList: Account[] = [];

  @Input() selectedLoan: Loan;
  @Output() passEntry = new EventEmitter<any>();

  selectedAccountId: number;

  //2-WAY BINDING INFO
  payArrearDate: Date;
  // remark: string;
  amount = 0;
  maxDate: Date = new Date();

  isExpanded: string;
  selectedArrearID: number;

  disabledSubmit = false;

  ngOnInit(): void {
    this.getAllArrearOfLoan();

    if (this.sharedService.isBranchAccountHandler()) {
      const companyID = Number(sessionStorage.getItem("companyId"));
      this.getAllAccountsOfCompany(companyID);
    }

    this.payArrearDate = this.maxDate;
  }

  getAllArrearOfLoan() {
    const xhttp = this.restApi.getRequest(this.constructApi.getLoanArrear(this.selectedLoan.ID));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArr = JSON.parse((xhttp.responseText));

        jsonArr.forEach(json => {
          const arrear = new Arrear(json.amount, json.date, json.id, json.loanId, json.remark, json.datePaid);

          if (arrear.DatePaid == undefined)
            this.unpaidArrearList.push(arrear);

          this.arrearList.push(arrear);
        });
      }
      this.arrearList.sort((a, b) => (a.ID > b.ID) ? 1 : -1);
    };
  }

  setSelectedStyle(arrearID: number) {
    this.selectedArrearID = this.unpaidArrearList[0].ID;

    if (arrearID === Number(this.selectedArrearID))
      return "lightcoral"
  }

  private getAllAccountsOfCompany(companyId: number) {
    // var xhttp = new XMLHttpRequest();
    // var url = "http://localhost:10080/api/v1/company/"+companyId+"/accounts";
    // xhttp.withCredentials = true;

    const xhttp = this.restApi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);
          const loggedInUser = sessionStorage.getItem("username");

          this.companyAccountList.push(account);
        });
      }
    };
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  isFieldNull() {
    const amountNull = (this.amount == undefined || this.amount == 0);
    // var remarkNull = (this.remark == undefined);
    const selectedAccountIdNull = (this.selectedAccountId == undefined)
    const amountValid = isNaN(+this.amount)

    return amountNull || selectedAccountIdNull || amountValid
  }

  setActive(type: string) {
    if (this.selectedLoan.Status == this.enums.SETTLED_LOAN) {
      if (type == 'Payment')
        return 'active';
      else
        return ''
    } else {
      if (type == 'History')
        return 'active';
      else
        return ''
    }
  }

  //THIS PART IS USING PAY ARREAR ENDPOINT TO PAY ARREAR
  // payArrear() {
  //   var data = {
  //     "amount": this.amount,
  //     // "interestCharge": this.amount,
  //     "accountId": Number(this.selectedAccountId),
  //     "datePaid": this.payArrearDate
  //   };

  //   var xhr = this.restApi.postRequest(this.constructApi.getLoanArrearPayment(this.selectedArrearID), data);
  //   xhr.onreadystatechange = () => {
  //     if (xhr.readyState == 4 && xhr.status == 200) {
  //       var json = JSON.parse(xhr.responseText);

  //       this.passEntry.emit(this.selectedLoan.ID)
  //       this.reset();
  //       this.sharedService.openAlert("Successfully paid arrear!");

  //     }
  //   }
  // }

  payArrear() {
    this.disabledSubmit = true;
    const data = {
      "repayment": 0,
      "stamp": 0,
      "serviceCharge": 0,
      "reserve": 0,
      "extras": [{ amount: 0 }],
      "AccountId": Number(this.selectedAccountId),
      "arrear": Number(this.amount),
      "discount": 0,
      "dateCreated": this.payArrearDate,
      "remark": "PAY ARREAR"
    };

    const xhr = this.restApi.postRequest(this.constructApi.getAddPayment(this.selectedLoan.ID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          this.passEntry.emit(this.selectedLoan.ID)
          this.reset();
          this.sharedService.openAlert("Successfully paid arrear!", ALERT_TYPE.SUCCESS);
        }
        else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  getAccountBalance() {
    const account = this.companyAccountList.find(account => account.ID === Number(this.selectedAccountId));
    return account.Balance;
  }

  submit() {
    if (this.isFieldNull())
      this.sharedService.openAlert("Please fill in all the fields!", ALERT_TYPE.DANGER);
    else
      this.payArrear();
  }

  reset() {
    this.activeModal.close();
  }

  // ARREAR HISTORY PART
  calculateTotalArrear(arrear: Arrear[]) {
    let numberOfArrear = 0;

    for (let i = 0; i < arrear.length; i++) {
      if (arrear[i].DatePaid == undefined)
        numberOfArrear++;
    }
    return numberOfArrear;
  }

  addPaidStyle(datePaid: Date) {
    if (datePaid != undefined)
      return 'paid';
  }

  confirmDeleteArrear(arrearID: number) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to delete this arrear?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.deleteArrear(arrearID);
    });
  }

  deleteArrear(arrearID: number) {
    const xhr = this.restApi.deleteRequest(this.constructApi.getSingleLoanArrear(this.selectedLoan.ID, arrearID));

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          if (xhr.status == 200) {
            window.location.reload();
          }
          else {
            this.sharedService.openAlert("Opps, some errors occured. Please try again later", ALERT_TYPE.DANGER);
          }
        }
      }
    }
  }
}
